/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as Cesium from "cesium";
import { CesiumLayer } from "../components/CesiumLayerSettings";
import {
  CesiumMeasurementItem,
  Custom3DTileset,
  CustomGeoJsonDataSource,
} from "../types/CesiumMapItems";

export function updateCesiumLayer(l: CesiumLayer, viewer: Cesium.Viewer): void {
  // Entities and primitives
  const fileIds: number[] = [];
  const { primitives } = viewer.scene;
  for (let i = 0; i < primitives.length; i++) {
    const p = primitives.get(i);
    if (
      p instanceof Cesium.Cesium3DTileset &&
      (p as Custom3DTileset).layer === l.title
    ) {
      p.show = l.visible;
      if (p.show) fileIds.push((p as Custom3DTileset).fileId);
    }
  }
  const entities = viewer.entities.values;
  entities.forEach((e) => {
    const properties = e.properties?.getValue(
      Cesium.JulianDate.now(),
    ) as CesiumMeasurementItem;
    if (
      properties &&
      properties.layer &&
      properties.layer === l.title &&
      !properties.files?.some((f) => fileIds.includes(f.id))
    ) {
      // eslint-disable-next-line no-param-reassign
      e.show = l.visible;
    }
  });
  // Data sources
  const { dataSources } = viewer;
  for (let i = 0; i < dataSources.length; i++) {
    const d = dataSources.get(i);
    if (
      d instanceof Cesium.GeoJsonDataSource &&
      (d as CustomGeoJsonDataSource).layer === l.title
    ) {
      d.show = l.visible;
    }
  }
}
